import { FC } from 'react';
import useTraining, {
  UseTrainingValue,
  TRAINING_INFO_ALERT_TYPES,
} from '../../hooks/useTraining';
import Player from '../Organisms/Player';

import TrainingHopSentences from '../Organisms/TrainingHopSentences';
import TrainingSkipSentences from '../Organisms/TrainingSkipSentences';
import TrainingJumpSentences from '../Organisms/TrainingJumpSentences';

import { TRAINING_MODE } from '../../utils/training/trainingUtil';

import AutoLogoffModal from '../Templates/AutoLogoffModal';
import ElmerModalAlert from '../Templates/ElmerModalAlert';
import PageLoadingLayer from '../Templates/PageLoadingLayer';
import TrainingCompleteDialog from '../Templates/TrainingCompleteDialog';

const Training: FC = () => {
  const useTrainingValue: UseTrainingValue = useTraining();
  const { audioControl } = useTrainingValue;
  const { trainingCompleteDialogValue } = useTrainingValue;
  // センテンスのコンポーネント
  const sentencesComponent = () => {
    switch (useTrainingValue.mode) {
      case TRAINING_MODE.HOP:
        return (
          <TrainingHopSentences
            sentenceData={useTrainingValue.trainingSentences}
            currentTime={useTrainingValue.currentTime}
          />
        );
      case TRAINING_MODE.SKIP:
        return (
          <TrainingSkipSentences
            sentenceData={useTrainingValue.trainingSentences}
            currentTime={useTrainingValue.currentTime}
          />
        );

      case TRAINING_MODE.JUMP:
        return (
          <TrainingJumpSentences
            sentenceData={useTrainingValue.trainingSentences}
            currentTime={useTrainingValue.currentTime}
          />
        );

      default:
        return (
          <TrainingHopSentences
            sentenceData={useTrainingValue.trainingSentences}
            currentTime={useTrainingValue.currentTime}
          />
        );
    }
  };

  return (
    <>
      {useTrainingValue.isCallingApi && <PageLoadingLayer />}
      <TrainingCompleteDialog
        isOpen={audioControl.isEnded}
        nextTrainingButtonTitle={
          trainingCompleteDialogValue.nextTrainingButtonTitle
        }
        completeCheckBoxChecked={
          trainingCompleteDialogValue.completeCheckboxChecked
        }
        onClickCloseButton={
          trainingCompleteDialogValue.onClickCloseCompleteDialog
        }
        onClickRepeat={trainingCompleteDialogValue.onClickRepeat}
        onClickNext={trainingCompleteDialogValue.onClickNextTraining}
        onClickTopicSelect={trainingCompleteDialogValue.onClickTopicSelect}
        onChangeCompleteCheckbox={
          trainingCompleteDialogValue.onChangeCompleteCheckbox
        }
        isCompleteCheckboxVisible={
          trainingCompleteDialogValue.isCompleteCheckboxVisible
        }
      />
      {useTrainingValue.trainingInfoAlert.type !== null &&
        (useTrainingValue.trainingInfoAlert.type ===
        TRAINING_INFO_ALERT_TYPES.INFO_LOGOFF ? (
          <AutoLogoffModal
            isModalOpen={useTrainingValue.trainingInfoAlert.type !== null}
            closeModal={useTrainingValue.onClickCloseModal}
          />
        ) : (
          <ElmerModalAlert
            isModalOpen={useTrainingValue.trainingInfoAlert.type !== null}
            alertTitle={useTrainingValue.trainingInfoAlert.alertTitle}
            alertText={useTrainingValue.trainingInfoAlert.alertText}
            alertButtons={useTrainingValue.trainingInfoAlert.alertButtons}
          />
        ))}

      <ElmerModalAlert
        isModalOpen={audioControl.isError}
        alertTitle={audioControl.audioErrorAlert.alertTitle}
        alertText={audioControl.audioErrorAlert.alertText}
        alertButtons={audioControl.audioErrorAlert.alertButtons}
      />
      {sentencesComponent()}
      <Player
        play={audioControl.play}
        pause={audioControl.pause}
        isPlaying={audioControl.isPlaying}
        toggleLoop={audioControl.toggleLoop}
        isLoop={audioControl.isLoop}
        leadTopic={audioControl.leadTopic}
        completeTopic={audioControl.completeTopic}
        playBackRate={audioControl.playBackRate}
        changePlayBackRate={audioControl.changePlayBackRate}
        nextSentence={audioControl.nextSentence}
        prevSentence={audioControl.prevSentence}
      />
    </>
  );
};

export default Training;
